// extracted by mini-css-extract-plugin
export var fullHeightState = "_5u-7";
export var headerCell = "_5u-1";
export var loadingStateCell = "_5u-4";
export var rowWrapper = "_5u-3";
export var standaloneTable = "_5u-8";
export var standaloneTableWithBodyFill = "_5u-9";
export var stateCell = "_5u-5";
export var table = "_5u-0";
export var tableBodyFiller = "_5u-6";
export var white = "_5u-2";